<template>
  <div>
      <Breadcrumb :home="bc_home" :model="bc_items" />
      <MailNavBar />
      <Card>
        <template #content>
          <h5>Webmail</h5>
          <div class="p-grid">
            <div class="p-col-3">
              User login:
            </div>
            <div class="p-col-9">
              Full email address (user@domain.tld)
            </div>
            <div class="p-col-3">
              Server name:
            </div>
            <div class="p-col-9">
              <a href="https://webmail.harborwall.com" target="_blank">https://webmail.harborwall.com</a>
            </div>
          </div>
          <h5>IMAP/POP3 Server Settings (Receiving)</h5>
          <div class="p-grid">
            <div class="p-col-3">
              User login:
            </div>
            <div class="p-col-9">
              Full email address (user@domain.tld)
            </div>
            <div class="p-col-3">
              Server name:
            </div>
            <div class="p-col-9">
              imap.harborwall.com <br />
              pop3.harborwall.com
            </div>
            <div class="p-col-3">
              Ports:
            </div>
            <div class="p-col-9">
              143 (IMAP) <br />
              110 (POP3)
            </div>
            <div class="p-col-3">
              Connection Security:
            </div>
            <div class="p-col-9">
              STARTTLS
            </div>
            <div class="p-col-3">
              Authentication Method:
            </div>
            <div class="p-col-9">
              Normal password
            </div>
          </div>
          <h5>SMTP Server Settings (Sending)</h5>
          <div class="p-grid">
            <div class="p-col-3">
              User login:
            </div>
            <div class="p-col-9">
              Full email address (user@domain.tld)
            </div>
            <div class="p-col-3">
              Server name:
            </div>
            <div class="p-col-9">
              smtp.harborwall.com
            </div>
            <div class="p-col-3">
              Port:
            </div>
            <div class="p-col-9">
              587
            </div>
            <div class="p-col-3">
              Connection Security:
            </div>
            <div class="p-col-9">
              STARTTLS
            </div>
            <div class="p-col-3">
              Authentication Method:
            </div>
            <div class="p-col-9">
              Normal password
            </div>
          </div>
          
        </template>
      </Card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getAttributes } from "../helpers/attributes.js"
import MailNavBar from '../components/MailNavBar.vue'

export default {
  name: 'MailHome',
  components: {
    MailNavBar,
  },
  data () {
    return {
      form: {
        label: ''
      },
      bc_home: {icon: 'pi pi-home', to: '/domains'},
      bc_items: [{icon: 'pi pi-spin pi-spinner'}],
      domain_name: "",
    }
  },
  created: function () {
    this.GetMailAccounts(this.$route.params.domain_id)
  },
  computed: {
    ...mapGetters({ MailAccounts: 'StateMailAccounts', Domains: 'StateDomains' }),
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    current_domain() {
      return this.MailAccounts
    }
  },
  methods: {
    ...mapActions(['GetMailAccounts']),
    //async submit () {
    //  await this.CreateDomain(this.form)
    //},
    //async selectDomain(id) {
    //  console.log("selectDomain", id)
    //  this.$router.push('/domains/' + id + '/mail/accounts')
    //  
    //}
  },
  watch: {
    current_domain (d) {
      if (d.domain && d.domain.name.length) {
        this.domain_name = d.domain.name
        this.bc_items = [
          {label: d.domain.name, to: '/domains/'+this.$route.params.domain_id},
          {label: 'Mail', to: '/domains/'+this.$route.params.domain_id+'/mail'}
        ]
      }
    },
  },
}
</script>

<style scoped>

</style>
